import axios from 'axios';
import actions from './actions';
import config from '../../../../config/index';
const _ = require('lodash');

const prepareContractAction = actions.Creators.prepareContract;
const onSigningEventAction = actions.Creators.onSigningEvent;
const handleSignContractErrorAction = actions.Creators.handleSignContractError;

const prepareContract = (contactUuid, submissionUuid) => async dispatch => {
	let params = {};
	params.submissionUuid = submissionUuid;
	let paramsReview = {};
	paramsReview.submissionUuid = submissionUuid;
	paramsReview.contactUuid = contactUuid;

	console.log('submissionUuid = ',submissionUuid);
	const responseContact = await axios.post(config.apiUrl + '/fundingPlatformPublic/contractReview/checkContact', paramsReview);
	let response = '';
	let contactSigningStatus = '';

	if (responseContact && responseContact.data.indexContact !== -1) {
		// Sign regular contract
		response = await axios.post(config.apiUrl + '/fundingPlatformPublic/signContract/prepareContract', params);
		contactSigningStatus = _.keyBy(response.data.contactsSigningStatus, 'contactUuid')[contactUuid];
	} else { 
		// Sign addendum contract - more than 2 owners
		params.contactUuid = contactUuid;
		response = await axios.post(config.apiUrl + '/fundingPlatformPublic/signAddendum/prepareContract', params);
		contactSigningStatus = _.keyBy(response.data.contactsSigningStatusAddendum, 'contactUuid')[contactUuid];
	}
	contactSigningStatus.eventListener = '';

	try {
		if (responseContact && responseContact.data.indexContact !== -1) {
        	dispatch(prepareContractAction({contactsSigningStatus: response.data.contactsSigningStatus, contactSigningStatus: contactSigningStatus, verifyContractStatus: response.data.verifyContractStatus}));
		} else {
			dispatch(prepareContractAction({contactsSigningStatus: response.data.contactsSigningStatusAddendum, contactSigningStatus: contactSigningStatus, verifyContractStatus: response.data.verifyContractStatusAddendum}));
		}	
	} catch(error) {
		dispatch(error);
	}
    return;
}

const onSigningEvent = (params) => async dispatch => {
	let contactUuid = params.contactUuid;

let submissionUuid = params.submissionUuid;

	let paramsReview = {};
	paramsReview.submissionUuid = submissionUuid;
	paramsReview.contactUuid = contactUuid;
	const responseContact = await axios.post(config.apiUrl + '/fundingPlatformPublic/contractReview/checkContact', paramsReview);

	let response = '';
	if (responseContact && responseContact.data.indexContact !== -1) {
		response = await axios.post(config.apiUrl + '/fundingPlatformPublic/signContract/onSigningEvent', params);
	} else {
		response = await axios.post(config.apiUrl + '/fundingPlatformPublic/signAddendum/onSigningEvent', params);
	}

	// const response = await axios.post(config.apiUrl + '/fundingPlatformPublic/signContract/onSigningEvent', params);
	let contactSigningStatus = _.keyBy(response.data.contactsSigningStatus, 'contactUuid')[contactUuid];
	contactSigningStatus.eventListener = response.data.event
	try {

		setTimeout(async () => {
			if (contactSigningStatus.status && contactSigningStatus.status === "Signed" && 
				contactSigningStatus.signatureId && contactSigningStatus.signatureId!=='' &&
				responseContact && responseContact.data.indexContact === -1) {
					console.table({signatureId: contactSigningStatus.signatureId, submissionUuid: submissionUuid, status: contactSigningStatus.status});
					await axios.get(config.apiUrl + `/webhooks/helloSign/uploadFile?submissionUuid=${submissionUuid}&signatureId=${contactSigningStatus.signatureId}&type=addendum`);
			}
		}, 10000);

        dispatch(onSigningEventAction({contactsSigningStatus: response.data.contactsSigningStatus, contactSigningStatus: contactSigningStatus}));
	} catch(error) {
		dispatch(error);
	}
    return;
}
const handleSignContractError = () => async dispatch => {
	try {
        dispatch(handleSignContractErrorAction());
	} catch(error) {
		dispatch(error);
	}
    return;
}

export default {
    prepareContract,
	onSigningEvent,
	handleSignContractError
  }